/* eslint-disable import/order */
import { RelatedContent, Resource } from '../components';
import { RESOURCE_DETAIL_AMPLITUDE_PAGE_NAME } from '../constants';
import { getResourceItemType } from '../helpers';
import { ResourceProps } from '../types';
import { MainFooter } from '@crehana/web';
import { getSourceEventParams, useAmplitude } from 'Jsx/Analytics/Amplitude';
import usePageView from 'Jsx/Analytics/UserActivity/usePageView';
import MainMenu from 'Jsx/CrehanaWeb/MainMenuWrapper';
import useFeatureFlagQuery from 'Jsx/Shared/Hooks/useFeatureFlagQuery';
import SEO from 'Jsx/Shared/SEO';
import { CountryPrefix } from 'Jsx/global';
import ResourceStructuredData from 'Shared/SEO/StructuredData/Resource';
import CapitalizeFirstLetter from 'crehana-utils/CapitalizeFirstLetter';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 18px auto 20px;
  width: 100%;
  .customWrapper {
    width: 90%;
    margin: 0 auto;
  }
  @media (min-width: 768px) {
    width: 520px;
    margin: 28px auto 40px;
    .customWrapper {
      width: 100%;
      margin: 0;
    }
  }
  @media (min-width: 1024px) {
    margin: 48px auto 30px;
    width: 768px;
  }
`;

type AppProps = {
  resource: ResourceProps;
  countryPrefix: CountryPrefix;
};

const App = ({ resource }: AppProps) => {
  const itemType = getResourceItemType(resource.category);
  const { logEvent } = useAmplitude();

  usePageView({ type: itemType || 'page', id: resource.originalId });

  const { isActive: showNotification } = useFeatureFlagQuery({
    flagKey: 'user_notification_web',
  });

  useEffect(() => {
    logEvent({
      // @ts-ignore
      event: 'Render Resource Detail',
      data: {
        ...getSourceEventParams(),
        'Resource name': resource.title,
      },
    });
  }, []);

  const breadcrumbs = resource.resourceCategory
    ? [
        {
          url: `recursos/${resource.category}/`,
          name: CapitalizeFirstLetter(resource.category),
        },
        {
          url: `recursos/${resource.category}/?categoria=${resource.resourceCategory.slug}`,
          name: resource.resourceCategory.name,
        },
        {
          url: `recursos/${resource.category}/${resource.title}`,
          name: resource.title,
          image: resource.coverUrl,
        },
      ]
    : [
        {
          url: `recursos/${resource.category}/`,
          name: CapitalizeFirstLetter(resource.category),
        },
        {
          url: `recursos/${resource.category}/${resource.title}`,
          name: resource.title,
          image: resource.coverUrl,
        },
      ];

  return (
    <React.Fragment>
      <MainMenu
        layoutConfig={{
          hideResourcesTools: true,
          hideShoppingCart: true,
          hideNotifications: !showNotification,
          hideTopBanner: true,
        }}
        amplitudePageName={RESOURCE_DETAIL_AMPLITUDE_PAGE_NAME}
      />
      <Wrapper>
        <div className="customWrapper" id="top-section">
          <SEO breadcrumbs={breadcrumbs} fontSize={12} />
        </div>
        <Resource resource={resource} itemType={itemType} />
      </Wrapper>
      <RelatedContent
        category={resource.category}
        resourceCategory={resource.resourceCategory}
      />
      <MainFooter />

      <ResourceStructuredData resource={resource} />
    </React.Fragment>
  );
};

export default App;
